export default "__VITE_ASSET__3868ed15__"